<template>
  <section
    v-if="config"
    class="market-builder"
  >
    <header class="market-builder-heading">
      <span aria-hidden="true">🛒</span>
      <div><h1>{{ copy.marketTitle }}</h1><p>{{ copy.marketIntro }}</p></div>
    </header>
    <dynamic-market
      :config="config"
      embedded
    />
  </section>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import market from '@/services/DynamicMarketService'
import DynamicMarket from './DynamicMarket.vue'
import messages from './dynamicMarketMessages'

export default {
  components: { DynamicMarket },
  data: () => ({ config: null }),
  computed: { copy() { return messages[this.$i18n.locale] || messages.en } },
  async created() {
    // Failure of the optional builder must never block the existing catalogue.
    try { const config = await market.config(); if (config && config.region) this.config = config } catch (error) { this.config = null }
  },
}
</script>

<style scoped>
.market-builder { margin-bottom: 32px; }
.market-builder-heading { display: flex; align-items: center; gap: 18px; margin: 0 0 28px; }
.market-builder-heading > span { font-size: 44px; }
.market-builder-heading h1 { color: #f7f6ff; font-size: clamp(28px, 4vw, 42px); font-weight: 800; margin: 0 0 6px; }
.market-builder-heading p { color: #b6b5d0; margin: 0; }
</style>
